import { render, staticRenderFns } from "./FarmEmpty.vue?vue&type=template&id=823dbf12&scoped=true&"
import script from "./FarmEmpty.vue?vue&type=script&lang=ts&"
export * from "./FarmEmpty.vue?vue&type=script&lang=ts&"
import style0 from "./farms-empty.scss?vue&type=style&index=0&id=823dbf12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823dbf12",
  null
  
)

export default component.exports